declare namespace $ {

	type $mol_paragraph__title_bog_merchquarium_help_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_text__text_bog_merchquarium_help_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_major__title_bog_merchquarium_help_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_merchquarium_help_4 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_help['settings'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_list__rows_bog_merchquarium_help_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_merchquarium_help_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_merchquarium_help_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_merchquarium_help_8 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_help['section_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_text__text_bog_merchquarium_help_9 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_help['section_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_bog_merchquarium_help_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_merchquarium_help_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_merchquarium_help extends $mol_list {
		Quick_title( ): $mol_paragraph
		Quick_text( ): $mol_text
		settings( next?: any ): any
		Quick_settings( ): $mol_button_major
		Quick( ): $mol_list
		Lead( ): $mol_paragraph
		icon( id: any): $mol_icon
		Section_icon( id: any): $mol_view
		section_title( id: any): string
		Section_title( id: any): $mol_paragraph
		section_text( id: any): string
		Section_text( id: any): $mol_text
		Section_body( id: any): $mol_list
		rows( ): readonly(any)[]
		Section( id: any): $mol_view
		Icon_about( ): $mol_icon_send_outline
		Icon_look( ): $mol_icon_palette_outline
		Icon_products( ): $mol_icon_storefront_outline
		Icon_tags( ): $mol_icon_tag_multiple
		Icon_import( ): $mol_icon_robot_outline
		Icon_preview( ): $mol_icon_eye_outline
		Icon_share( ): $mol_icon_share_variant
		Icon_access( ): $mol_icon_account_multiple
		about_title( ): string
		about_text( ): string
		look_title( ): string
		look_text( ): string
		products_title( ): string
		products_text( ): string
		tags_title( ): string
		tags_text( ): string
		import_title( ): string
		import_text( ): string
		preview_title( ): string
		preview_text( ): string
		share_title( ): string
		share_text( ): string
		access_title( ): string
		access_text( ): string
	}
	
}

//# sourceMappingURL=help.view.tree.d.ts.map